import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const ArticlesList = () => {
  const [articles, setArticles] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    fetch("/articles.json")
      .then((response) => response.json())
      .then((data) => setArticles(data))
      .catch((error) => console.error("❌ Erreur de chargement :", error));
  }, []);

  // 🔍 Filtrer les articles en fonction de la recherche
  const filteredArticles = articles.filter(
    (article) =>
      article.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      article.theme.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="container">
      {/* Featured Posts Section */}
      <h3 style={{ marginLeft: "50px", fontWeight: "bold", marginTop: 15 }}>
        Featured Posts
      </h3>
      <div className="d-flex flex-wrap justify-content-center">
        {articles.slice(0, 3).map((article, index) => (
          <div
            key={index}
            className="card custom-card m-3"
            style={{ width: "18rem" }}
          >
            <img
              src={article.image}
              className="card-img-top"
              alt={article.title}
            />
            <div className="card-body">
              <Link
                to={`/article/${article.id}`}
                style={{ textDecoration: "none", color: "black" }}
              >
                <h5 className="card-title">{article.title}</h5>
              </Link>
              <h6 className="card-subtitle text-muted">{article.theme}</h6>
              <p className="card-text">{article.description}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Archive Section */}
      <h3 style={{ marginLeft: "50px", fontWeight: "bold", marginTop: 15 }}>
        Archive
      </h3>
      <div className="search-bar-container">
        <div className="search-wrapper">
          <span className="search-icon">
            <i className="fas fa-search"></i>
          </span>
          <input
            type="text"
            placeholder="Search Posts by Title or Theme..."
            className="form-control search-input"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      {/* Display filtered articles */}
      {filteredArticles.length > 0 ? (
        <div className="d-flex flex-wrap justify-content-center">
          {filteredArticles.map((article, index) => (
            <div
              key={index}
              className="card custom-card m-3"
              style={{ width: "18rem" }}
            >
              <img
                src={article.image}
                className="card-img-top"
                alt={article.title}
              />
              <div className="card-body">
                <Link
                  to={`/article/${article.id}`}
                  style={{ textDecoration: "none", color: "black" }}
                >
                  <h5 className="card-title">{article.title}</h5>
                </Link>
                <h6 className="card-subtitle text-muted">{article.theme}</h6>
                <p className="card-text">{article.description}</p>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="no-results">
          <p>No Posts found</p>
          <button
            className="btn btn-secondary"
            onClick={() => setSearchTerm("")}
          >
            Clear Filters
          </button>
        </div>
      )}
    </div>
  );
};

export default ArticlesList;
